import React from 'react'
import DarkImg from './images/darkmode.png';
import GeoHealth from './images/GeoHealth.png'
function Navbar(props) {
  return (
    <div>
      <nav class={`navbar navbar-expand-lg navbar-${props.mode} bg-${props.mode}`}>
  <div class="container-fluid">
    <a class="navbar-brand" href="/"><img src={GeoHealth} style={{height:'32px'}}/>GeoHealth</a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarTogglerDemo02" aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarTogglerDemo02">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <li class="nav-item">
          <a class="nav-link" href="https://www.siddhartha.ml/" target="_blank">About</a>
        </li>
      </ul>
      <div class="form-check form-switch">
      <label class={`form-check-label text-${props.mode==='light'?'dark':'light'}`} for="flexSwitchCheckDefault">Enable DarkMode <img src={DarkImg} style={{height:'30px'}}/></label>
  <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" onChange={props.changeMode}/>

</div>
    </div>
  </div>
</nav>
    </div>
  )
}

export default Navbar
